import AppFooter from './AppFooterContainer';

export { AppFooter };


// WEBPACK FOOTER //
// ./src/modules/home/AppFooter/index.js